export default __webpack_public_path__ + "static/media/bsc.c0174b21.svg";